function isNumber (text) {
  const pattern = /^\d+$/
  return pattern.test(text)
}

export {isNumber}



// WEBPACK FOOTER //
// ./src/utils/rules.js